<script setup lang="ts">
import { IconClose, IconInformationCircleFilled, IconCheckCircleFilled } from '../../icons';

type IconsType = 'info' | 'success';

interface IProps {
  text?: string;
  lineClamp?: number;
  closable?: boolean;
  icon?: IconsType;
}

const props = withDefaults(defineProps<IProps>(), {
  lineClamp: 5,
  text: '',
  closable: false,
  icon: 'info',
});

defineEmits<{ (e: 'close'): void }>();

const textStyleObj = computed(() => ({
  '-webkit-line-clamp': props.lineClamp,
  lineClamp: props.lineClamp,
}));
</script>

<template>
  <div class="snackbar">
    <IconInformationCircleFilled v-if="icon === 'info'" class="snackbar__icon" />
    <IconCheckCircleFilled v-else-if="icon === 'success'" class="snackbar__icon" />

    <span class="snackbar__text" :style="textStyleObj">{{ text }} </span>

    <div v-if="props.closable" class="snackbar__close" @click="$emit('close')">
      <IconClose />
    </div>
  </div>
</template>

<style lang="stylus" scoped>
.snackbar
  display flex
  gap var(--spacing150)
  background-color var(--background-popover-inverted)
  padding var(--spacing175, 14px) var(--rounding250, 20px)
  border-radius var(--rounding250)
  color: var(--text-inverse-primary)
  box-sizing border-box
  align-items center
  & *
    box-sizing border-box
  +Media(Mobile, Tablet)
    padding 12px 16px

  &__icon
    font-size 24px

  &__text
    line-height var(--typography-line-height-default-body-m)
    font-size var(--typography-font-size-body-m)
    font-family var(--typography-font)
    margin-top var(--spacing100)
    margin-bottom var(--spacing100)
    display -webkit-box
    -webkit-box-orient vertical
    overflow hidden

  &__close
    font-size 24px
    height 36px
    width 36px
    min-width 36px
    display flex
    align-items center
    justify-content center
    border-radius var(--rounding100)
    transition-duration .2s
    cursor pointer
    margin-left auto

    &:hover
      background-color rgba(255, 255, 255, .1)
</style>
